// src/components/UI/PopupWrapper.js
import React, { useRef, useEffect } from 'react';

const PopupWrapper = ({ onClose, children }) => {
  const wrapperRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Delay adding the listener so that the click that opens the popup doesn't immediately close it
    const timer = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={wrapperRef} className="popup-wrapper">
      {children}
    </div>
  );
};

export default PopupWrapper;
